import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';

import { TabsPage } from './tabs.page';
import { AuthguardGuard } from '../../guards/authguard.guard';
import {  WelcomeguardGuard} from "../../guards/welcomeguard.guard";
import { ChooseclientGuard } from 'src/app/guards/chooseclient.guard';
import { IsLoggedInGuard } from 'src/app/guards/is-logged-in.guard';
import { TtuFormAuthGuard } from 'src/app/guards/ttu-form-auth.guard';
import { AppealsGuard } from 'src/app/guards/appeals.guard';
import { PermitsGuard } from 'src/app/guards/permits.guard';
import { RealtimeMapGuard } from 'src/app/guards/realtime-map.guard';
import { FormsGuard } from 'src/app/guards/forms.guard';
import { LockersGuard } from 'src/app/lockers.guard';
const routes: Routes = [
  {path: '', redirectTo: 'home', pathMatch: 'full'},
  {
    path: '',
    component: TabsPage,
    children: [
      {
        path: 'home',
      canActivate:[AuthguardGuard],
      loadChildren: () =>
        import('../home/home.module').then((m) => m.HomePageModule)
      },
      {
        path: 'password/reset/:token',
        loadChildren: () => import('../../pages/password/reset/reset.module').then( m => m.ResetPageModule)
      },
  {
    path: 'login',
    
    canActivate:[IsLoggedInGuard],
    loadChildren: () =>
      import('../login/login.module').then((m) => m.LoginPageModule),
  },
  {
    path: 'register',
    canActivate:[IsLoggedInGuard],
    loadChildren: () =>
      import('../register/register.module').then(
        (m) => m.RegisterPageModule
      ),
  },
  
  {
    path: 'vehicles',
    canActivate:[AuthguardGuard],
    loadChildren: () =>
      import('../vehicles/vehicles.module').then(
        (m) => m.VehiclesPageModule
      ),
  },
  {
    path: 'permits',
    canActivate:[AuthguardGuard,PermitsGuard],
    loadChildren: () =>
      import('../permits/permits.module').then((m) => m.PermitsPageModule),
  },
  {
    path: 'violations/appeals',
    canActivate:[AuthguardGuard,AppealsGuard],
    loadChildren: () =>
      import('../appeals/appeals.module').then((m) => m.AppealsPageModule),
  },
  {
    path: 'lockers',
    canActivate:[AuthguardGuard,LockersGuard],
    loadChildren: () =>
      import('../lockers/lockers.module').then((m) => m.LockersPageModule),
  },
  {
    path: 'forms',
    canActivate:[AuthguardGuard,FormsGuard],
    loadChildren: () =>
      import('../forms/forms.module').then((m) => m.FormsPageModule),
  },
  {
    path: 'account',
    loadChildren: () =>
      import('../account/account.module').then((m) => m.AccountPageModule),
  },
  
  {
    path: 'realtime-parking',
    canActivate:[RealtimeMapGuard],
    loadChildren: () => import('../../pages/realtime-parking/realtime-parking.module').then( m => m.RealtimeParkingPageModule)
  }
  ,
  {
    path: 'edit-address',
    canActivate:[AuthguardGuard],
    loadChildren: () =>
      import('../../modals/edit-address/edit-address.module').then(
        (m) => m.EditAddressPageModule
      ),
  },
  
  {
    path: 'violation-info',
    canActivate:[AuthguardGuard],
    loadChildren: () => import('../../modals/violation-info/violation-info.module').then( m => m.ViolationInfoPageModule)
  },
  {
    path: 'locker-info',
    canActivate:[AuthguardGuard],
    loadChildren: () => import('../../modals/locker-info/locker-info.module').then( m => m.LockerInfoPageModule)
  },
  {
    path: 'permit-info',
    canActivate:[AuthguardGuard],
    loadChildren: () => import('../../modals/permit-info/permit-info.module').then( m => m.PermitInfoPageModule)
  },
  {
    path: 'chooseclient',
    canActivate:[WelcomeguardGuard],
    loadChildren: () => import('../../pages/chooseclient/chooseclient.module').then( m => m.ChooseclientPageModule)
  },
  {
    path: 'realtimemodal',
    loadChildren: () => import('../../pages/realtimemodal/realtimemodal.module').then( m => m.RealtimemodalPageModule)
  },
  {
    path: 'qrscanner',
    loadChildren: () => import('../../pages/qrscanner/qrscanner.module').then( m => m.QrscannerPageModule)
  },
  {
    path: 'forgotpassword',
    loadChildren: () => import('../../pages/forgot-password/forgot-password.module').then( m => m.ForgotPasswordPageModule)
  },
  
  {
    path: 'one_time_password',
    canActivate:[AuthguardGuard],
    loadChildren: () => import('../one-time-password/one_time_password.module').then( m => m.OneTimePasswordPageModule)
  },
  {
    path: ':customPath',
    loadChildren: () => import('../../pages/custompage/custompage.module').then( m => m.CustompagePageModule)
  },
  {
    path: 'permits/temporary/reservation/:id',
    canActivate:[AuthguardGuard],
    loadChildren: () => import('../../modals/temporary-permit/temporary-permit.module').then( m => m.TemporaryPermitPageModule)
  },
  {
    path: 'permits/standard/reservation/:id',
    canActivate:[AuthguardGuard],
    loadChildren: () => import('../../modals/standard-permit/standard-permit.module').then( m => m.StandardPermitPageModule)
  },
  {
    path: 'permits/standard/reservation/:id?waitlist=1',
    canActivate:[AuthguardGuard],
    loadChildren: () => import('../../modals/waiting-list/waiting-list.module').then( m => m.WaitingListPageModule)
  },
  {
    path: 'custom_form/ttu/miscellaneous_deductions',
    canActivate:[AuthguardGuard,TtuFormAuthGuard],
    loadChildren: () => import('../../forms/deductions-form/deductions-form.module').then( m => m.DeductionsFormPageModule)
  },
  {
    path: 'permits/qrcode/reservation/:id',
    loadChildren: () => import('../../modals/qrcode-permit/qrcode-permit.module').then( m => m.QrcodePermitPageModule)
  },
  {path: 'receipt/:confirmcode',
  loadChildren: () => import('../../modals/receipt/receipt.module').then( m => m.ReceiptPageModule)},
  {path: '',
  
  redirectTo: '/welcome'}
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class TabsPageRoutingModule {}
